import { render, staticRenderFns } from "./TransitionText.vue?vue&type=template&id=06e1121e&"
import script from "./TransitionText.vue?vue&type=script&lang=js&"
export * from "./TransitionText.vue?vue&type=script&lang=js&"
import style0 from "./TransitionText.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports